import React from "react"
import {
  Button,
  Link,
  CreateButton,
  TopToolbar,
  List,
  Pagination,
  PaginationActions,
  Datagrid,
  EmailField,
  FunctionField,
} from "react-admin"
import { Email } from "@material-ui/icons"

function SiteMailoutLink({ record }) {
  return record ? (
    <Button
      component={React.forwardRef((props, ref) => (
        <Link {...props} innerRef={ref} />
      ))}
      to={`/site-mailouts/mailout`}
      label="Рассылка"
    >
      <Email />
    </Button>
  ) : null
}

function SiteMailoutListActions({ basePath, data }) {
  return (
    <TopToolbar>
      <CreateButton basePath={basePath} />
      <SiteMailoutLink record={data} />
    </TopToolbar>
  )
}

export default function SiteMailoutList(props) {
  const MailoutPaginationActions = (props) => (
    <PaginationActions color="secondary" {...props} />
  )
  const MailoutPagination = (props) => (
    <Pagination actions={MailoutPaginationActions} {...props} />
  )
  return (
    <List
      {...props}
      pagination={<MailoutPagination />}
      actions={<SiteMailoutListActions />}
    >
      <Datagrid rowClick="edit" size="medium">
        <EmailField source="email" label="Email" />
        <FunctionField
          render={(record) => `${record.firstName} ${record.lastName}`}
          label="Имя"
        />
      </Datagrid>
    </List>
  )
}
